var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('force-landscape',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticStyle:{"z-index":"6"},attrs:{"forceLandscape":_vm.needForceLandscape}},[_c('div',{staticClass:"mask",on:{"click":_vm.hide}}),_vm._v(" "),_c('div',{staticClass:"download-wrap",style:([_vm.isMobile ? {
      width: _vm.mWidth,
      height: _vm.mHeight,
      backgroundImage: _vm.imageUrl
    } : {
      width: '35%',
      height: '100%',
      backgroundImage: _vm.imageUrl
    }]),on:{"click":_vm.handleDownload}},[(_vm.showCloseBtn)?_c('div',{staticClass:"closebtn",on:{"click":_vm.hide}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }